<template>
  <router-view />
</template>
<script>
  export default {
    name: 'UnidadeModule',
  }
</script>
